<mat-form-field class="notes-input" appearance="outline">
  <mat-label>{{ 'MEDDIC.REASON_FOR_SCORE' | translate }}</mat-label>
  <textarea
    [placeholder]="'MEDDIC.REASON_FOR_SCORE' | translate"
    [formControl]="formControl"
    matInput
    cdkTextareaAutosize
    cdkAutosizeMinRows="3"
    cdkAutosizeMaxRows="8"
  ></textarea>
  <mat-icon matSuffix *ngIf="(notesSaveStatus$ | async) === NOTES_STATUS_ERROR">report_problem</mat-icon>
  <mat-icon matSuffix *ngIf="(notesSaveStatus$ | async) === NOTES_STATUS_SAVED">done</mat-icon>
  <mat-spinner [diameter]="16" matSuffix *ngIf="(notesSaveStatus$ | async) === NOTES_STATUS_SAVING"></mat-spinner>
</mat-form-field>
